import React from "react";
import PropTypes from 'prop-types';
import classNames from "classnames";
import styles from "./styles.module.scss";

const getDefaultComponent = (variant) => {
    switch (variant) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
            return variant;
        default:
            return "p";
    }
};

export const Typography = ({
    variant = "body1",
    weight = "regular",
    align = "left",
    color,
    className,
    children,
    component,
    truncate = false,
    gutterBottom = false,
}) => {
    const Component = component || getDefaultComponent(variant);

    const classes = classNames(
        styles.typography,
        styles[`typography--${variant}`],
        styles[`typography--${weight}`],
        styles[`typography--align-${align}`],
        {
            [styles["typography--truncate"]]: truncate,
            [styles["typography--gutter-bottom"]]: gutterBottom,
        },
        className,
    );

    return (
        <Component className={classes} style={color ? { color } : undefined}>
            {children}
        </Component>
    );
};

Typography.propTypes = {
    variant: PropTypes.oneOf([
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'body1', 'body2', 'subtitle1', 'subtitle2',
        'caption', 'overline'
    ]),
    weight: PropTypes.oneOf(['regular', 'medium', 'semibold', 'bold']),
    align: PropTypes.oneOf(['left', 'center', 'right']),
    color: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    component: PropTypes.string,
    truncate: PropTypes.bool,
    gutterBottom: PropTypes.bool,
};


export default Typography;
